import { render, staticRenderFns } from "./handCardPay.vue?vue&type=template&id=60151b2c&scoped=true&"
import script from "./handCardPay.vue?vue&type=script&lang=js&"
export * from "./handCardPay.vue?vue&type=script&lang=js&"
import style0 from "./handCardPay.vue?vue&type=style&index=0&id=60151b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60151b2c",
  null
  
)

export default component.exports